<template>
  <div class="HelloIm-wrapper">
    <SectionTitle heading="Hello I'm" />
    <div class="self-introduction-flex">
      <div v-for="(intro, index) in introductions" :key="index" class="self-introduction">
        <div class="self-sns">
          <a v-if="intro.snsTwitter" :href="intro.snsTwitter" target="_blank" rel="noopener noreferrer">
            <img src="@/assets/img/about/twitter_x_icon.png" alt="Twitter" />
          </a>
          <a v-if="intro.snsInstagram" :href="intro.snsInstagram" target="_blank" rel="noopener noreferrer">
            <img src="@/assets/img/about/insta_icon.png" alt="Instagram" />
          </a>
          <a v-if="intro.snsFacebook" :href="intro.snsFacebook" target="_blank" rel="noopener noreferrer">
            <img src="@/assets/img/about/fb_icon.png" alt="Facebook" />
          </a>
        </div>
        <img :src="intro.thumbnailImage || defaultImagePath" class="self-img" @error="onImageError($event)"
          alt="Thumbnail" />
        <div class="self-name-wrapper">
          <h4 class="self-name-ja">
            {{ intro.name_ja }}&emsp;<span>{{ intro.name_en }}</span>
          </h4>
        </div>
        <div class="self-texts-wrapper">
          <div>Job : {{ intro.occupation }}</div>
          <div>Favorite fish 🐟 : {{ intro.favoriteFish }}</div>
          <div class="self-interest-wrapper">
            <div class="interests">Interests :</div>
            <p v-html="formatInterests(intro.interests)"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import SectionTitle from "@/features/about/components/SectionTitle.vue";

export default {
  name: "SelfIntroduction",
  components: { SectionTitle },
  data() {
    return {
      introductions: [],
      defaultImagePath: require('@/assets/img/common/SABA.png'), // デフォルト画像パス
    };
  },
  async created() {
    await this.fetchIntroductions();
  },
  methods: {
    // データをAPI Gatewayから取得
    async fetchIntroductions() {
      const API_GATEWAY_URL = "https://hin850buj4.execute-api.ap-northeast-1.amazonaws.com/prod/FetchSelfIntro";
      try {
        const response = await axios.get(API_GATEWAY_URL);
        this.introductions = response.data;
      } catch (error) {
        console.error("Error fetching introductions:", error);
      }
    },
    // 改行を <br> に変換
    formatInterests(interests) {
      return interests ? interests.replace(/\n/g, "<br>") : "";
    },
    // 画像エラー時にデフォルト画像を設定
    onImageError(event) {
      event.target.src = this.defaultImagePath;
    },
  },
};
</script>

<style scoped>
.HelloIm-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: auto;
  width: 100%;
}

.self-introduction-flex {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
  row-gap: 50px;
}

.self-introduction {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 30px;
  padding-bottom: 110px;
  width: calc(50% - 50px);
  height: auto;
  font-family: sans-serif;
}

.self-sns {
  width: auto;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 30px;
}

.self-sns img {
  width: 17px;
  height: 17px;
  object-fit: cover;
}

.self-img {
  z-index: 1;
  width: 230px;
  height: 230px;
  object-fit: cover;
  border-radius: 100%;
  border: none;
}

.self-name-wrapper {
  width: 350px;
  height: auto;
  color: #565452;
  text-align: center;
}

.self-name-ja {
  font-size: 18px;
  font-weight: 400;
}

.self-name-ja span {
  font-size: 14px;
  font-weight: 300;
}

.self-texts-wrapper {
  width: 350px;
  height: auto;
  font-size: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: start;
  row-gap: 13px;
  color: #565452;
}

.self-interest-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  column-gap: 10px;
}

.interests{
  text-wrap: nowrap;
}

.self-interest-wrapper p {
  padding: 0%;
  margin: 0%;
  text-wrap: wrap;
}

@media screen and (max-width: 1024px) {

  .self-introduction-flex {
    width: 100%;
    flex-direction: column;
    justify-content: center;
    row-gap: 30px;
  }

  .self-introduction {
    width: 100%;
    row-gap: 30px;
    padding-bottom: 100px;
  }

  .self-sns img {
    width: 18px;
    height: 18px;
  }

  .self-img {
    width: 230px;
    height: 230px;
  }

  .self-name-wrapper {
    width: auto;
  }

  .self-name-ja {
    font-size: 17px;
    font-weight: 400;
  }

  .self-name-ja span {
    font-size: 14px;
    font-weight: 300;
  }

  .self-texts-wrapper {
    width: 100%;
    height: auto;
    font-size: 15px;
  }


}

@media screen and (max-width: 570px) {

  .self-introduction-flex {
    width: 100%;
    flex-direction: column;
    justify-content: center;
    row-gap: 0px;
  }

  .self-introduction {
    width: 100%;
    row-gap: 30px;
    padding-bottom: 100px;
  }

  .self-sns img {
    width: 13px;
    height: 13px;
  }

  .self-img {
    width: 180px;
    height: 180px;
  }

  .self-name-wrapper {
    width: auto;
  }

  .self-name-ja {
    font-size: 14px;
    font-weight: 400;
  }

  .self-name-ja span {
    font-size: 12px;
    font-weight: 300;
  }

  .self-texts-wrapper {
    width: 100%;
    height: auto;
    font-size: 13px;
  }
}
</style>